<template>
  <div class="figure__wrapper" :class="{'figure__wrapper-details': isDetails}">
    <svg :width="defaultSvgParams.width * figureSvgScale"
         :height="defaultSvgParams.height * figureSvgScale"
         :viewBox="`0 0 ${defaultSvgParams.width * figureSvgScale}
         ${defaultSvgParams.height * figureSvgScale}`"
         ref="figure"
         @mouseover="detectCursor()"
         @mouseout="unDetectCursor()"
         :style="{transform: `scale(${zoom})`}">
      <line
        x1="0"
        :y1="changeHeightUp"
        :x2="defaultSvgParams.width"
        :y2="changeHeightUp"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> //ruler horizontal top
      <line
        x1="0"
        :y1="changeHeightUp + scaledBiasHeight"
        :x2="defaultSvgParams.width"
        :y2="changeHeightUp + scaledBiasHeight"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> // ruler horizontal bottom 1
      <line
        x1="0"
        :y1="changeHeightDown + scaledBiasHeight"
        :x2="defaultSvgParams.width"
        :y2="changeHeightDown + scaledBiasHeight"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> // ruler horizontal bottom 2
      <line
        :x1="changeWidthLeft"
        y1="0"
        :x2="changeWidthLeft"
        :y2="defaultSvgParams.height"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> // ruler vertical 1
      <line
        :x1="changeWidthLeft + scaledBiasWidth"
        y1="0"
        :x2="changeWidthLeft + scaledBiasWidth"
        :y2="defaultSvgParams.height"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> // ruler vertical 2
      <line
        :x1="changeWidthRight"
        y1="0"
        :x2="changeWidthRight"
        :y2="defaultSvgParams.height"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> // ruler vertical 3
      <path :d="arrowHeight" fill="none" :stroke="isDetails ? arrowsColor : '#1FAFED'"
        stroke-width="2" style="stroke-linecap: round;" v-if="!isNav"></path> // arrow height
      <path :d="arrowWidth" fill="none" :stroke="isDetails ? arrowsColor : '#C6B4FB'"
        stroke-width="2" style="stroke-linecap: round;" v-if="!isNav"></path> // arrow width
      <path :d="arrowBiasHeight" fill="none" :stroke="isDetails ? arrowsColor : '#F5BB4A'"
        stroke-width="2" style="stroke-linecap: round;" v-if="!isNav"></path> // arrow bias height
      <path :d="arrowBiasWidth" fill="none" :stroke="isDetails ? arrowsColor : '#FF6928'"
        stroke-width="2" style="stroke-linecap: round;" v-if="!isNav"></path> // arrow bias width
      <path :d="arrowDirection" fill="none" :stroke="arrowStrokeColor"
        :stroke-width="strokeWidth" style="stroke-linecap: round;"
        v-if="!isDetails"></path> // arrow Direction
      <defs v-if="isPlate">
        <clipPath id="figureMask">
          <path :d="cornerLeftBottomMask" fill="none" :stroke="figureStrokeColor"
           :stroke-width="strokeWidth"
            style="stroke-linecap: round;"></path> // corner left bottom mask
        </clipPath>
      </defs>
      <text :x="changeWidthRight + 20"
            :y="changeHeightUp + changeHeightDown / 2 - (scaledBiasHeight / 2)"
            fill="#333333"
            text-anchor="middle"
            v-if="isDetails"
            :transform="`rotate(-90 ${changeWidthRight + 20}
            ${changeHeightUp + changeHeightDown / 2 - (scaledBiasHeight / 2)})`">
              {{ slopeParams.height }} m
      </text>
      <text :x="changeWidthLeft - 10"
            :y="(this.changeHeightUp + scaledBiasHeight / 2)"
            fill="#333333"
            text-anchor="middle"
            v-if="isDetails"
            :transform="`rotate(-90 ${changeWidthLeft - 10}
            ${(this.changeHeightUp + scaledBiasHeight / 2)})`">
              {{ slopeParams.biasHeight }} m
      </text>
      <text :x="`${this.changeWidthLeft + (scaledBiasWidth / 2)}`"
            :y="changeHeightUp - 10" fill="#333333"
            text-anchor="middle" v-if="isDetails">{{ slopeParams.biasWidth }}
        m
      </text>
      <text :x="`${(this.defaultSvgParams.width * this.figureSvgScale) / 2}`"
            :y="changeHeightDown + scaledBiasHeight + 20" fill="#333333"
            text-anchor="middle" v-if="isDetails">{{ slopeParams.width }} m</text>
      <g v-if="isDetails" clip-path="url(#figureMask)"> <!--clip-path="url(#figureMask)"-->
          <g>
            <g v-for="i in rowsCount" :key="i" class="row__overlay">
              <rect :x="changeWidthRight - (plateWidth * (i))"
                    :y="i % 2 === 0 ? rowStartY - (plateHeight / 2)
                    : rowStartY"
                    :width="plateWidth - 1"
                    :height="i % 2 === 0 ? rowHeight + plateHeight : rowHeight"
                    fill="#F6F6F6" stroke="#999999"
                    stroke-width="1"
                    style="shape-rendering: crispEdges;"
                    @mouseover="showRowInfo(i)"
                    @mouseout="hideRowInfo()"
                    ></rect>
              <line :x1="changeWidthRight - (plateWidth * (i))"
                    :y1="i % 2 === 0 ? (rowStartY - (plateHeight / 2)) + (plateHeight * n)
                    : rowStartY + (plateHeight * n)"
                    :x2="changeWidthRight - (plateWidth * (i)) + plateWidth - 1"
                    :y2="i % 2 === 0 ? (rowStartY - (plateHeight / 2)) + (plateHeight * n)
                    : rowStartY + (plateHeight * n)"
                    stroke="#999999"
                    stroke-width="1"
                    style="shape-rendering: crispEdges;"
                    v-for="n in i % 2 === 0 ? (itemPerRow) : (itemPerRow - 1)" :key="n"></line>
            </g>
          </g>
      </g>
      <path :d="cornerLeftBottom" fill="none" :stroke="figureStrokeColor"
        :stroke-width="strokeWidth"
        style="stroke-linecap: round;"></path> // corner left bottom
      <!--<line
        :x1="changeWidthLeft"
        :y1="changeHeightUp + scaledBiasHeight"
        :x2="changeWidthLeft"
        :y2="changeHeightDown + scaledBiasHeight"
        stroke="yellow" stroke-width="4" style="stroke-linecap: round;" /> // left side
      <line
        :x1="changeWidthRight"
        :y1="changeHeightUp + scaledBiasHeight"
        :x2="changeWidthRight"
        :y2="changeHeightDown + scaledBiasHeight"
        stroke="blue" stroke-width="4" style="stroke-linecap: round;" /> // right side
      <line
        :x1="changeWidthLeft"
        :y1="changeHeightDown + scaledBiasHeight"
        :x2="changeWidthRight"
        :y2="changeHeightDown + scaledBiasHeight"
        stroke="green" stroke-width="4" style="stroke-linecap: round;" /> // bottom side
      <line
        :x1="changeWidthLeft + scaledBiasWidth"
        :y1="changeHeightUp + scaledBiasHeight"
        :x2="changeWidthRight"
        :y2="changeHeightUp + scaledBiasHeight"
        stroke="red" stroke-width="4" style="stroke-linecap: round;"/> // top side right
      <line
        :x1="changeWidthLeft"
        :y1="changeHeightUp"
        :x2="changeWidthLeft"
        :y2="changeHeightUp + scaledBiasHeight"
        stroke="brown" stroke-width="4" style="stroke-linecap: round;"/> // bias height left
      <line
        :x1="changeWidthLeft + scaledBiasWidth"
        :y1="changeHeightUp"
        :x2="changeWidthLeft + scaledBiasWidth"
        :y2="changeHeightUp + scaledBiasHeight"
        stroke="violet" stroke-width="4" style="stroke-linecap: round;"/> // bias height right
      <line
        :x1="changeWidthLeft"
        :y1="changeHeightUp"
        :x2="changeWidthLeft + scaledBiasWidth"
        :y2="changeHeightUp"
        stroke="lime" stroke-width="4" style="stroke-linecap: round;"/> // top side left-->
    </svg>
      <!--<div class="data" v-if="!isNav">
        <h1>coefitient: {{ scale }}</h1>
        <h1>scaleH: {{ scaleH }}</h1>
        <h1>scaleW: {{ scaleW }}</h1>
      </div>-->
    <MyPopover
      :rowId = "rowId"
      :layersCount = "slopeFromState.slopeLayersCount"
      :plateHeight = "slopeFromState.materialSize.height"
      :plateWidth = "slopeFromState.materialSize.width"
      :windowWidth = "windowWidth"
      :materialAngle = "materialAngle"
      :fixtureCalculationThickness = "fixtureCalculationThickness"
      :masonryType="masonryType"
      :backEndRowsCount="backEndRowsCount"
      :hKr="hKr"
      :qKr="qKr"
      :y1="y1"
      :y2="y2"
      :mouseLeft = "mouseLeft"
      :mouseTop = "mouseTop"
    />
  </div>
</template>

<script>

import MyPopover from '../MyPopover.vue';

export default {
  props: {
    isNav: Boolean,
    defaultSvgParams: Object,
    isDetails: Boolean,
    isPlate: Boolean,
    navId: Number,
    zoom: Number,
    materialAngle: Number,
    fixtureCalculationThickness: Number,
    backEndRowsCount: Number,
    masonryType: String,
    hKr: Number,
    qKr: Number,
    y1: Number,
    y2: Number,
  },
  data() {
    return {
      rowId: 0,
      mouseTop: null,
      mouseLeft: null,
      windowWidth: null,
    };
  },
  components: {
    MyPopover,
  },
  watch: {
    slopeParams: {
      deep: true,
      handler() {
        // eslint-disable-next-line no-unused-expressions
        (this.slopeParams.biasWidth > this.slopeParams.width)
          ? this.slopeParams.biasWidth = this.slopeParams.width
          : this.slopeParams.width = this.slopeParams.width;
        // eslint-disable-next-line no-unused-expressions
        (this.slopeParams.biasWidth >= this.slopeParams.width)
          ? this.slopeParams.biasWidth = this.slopeParams.width
          : this.slopeParams.biasWidth = this.slopeParams.biasWidth;
      },
    },
    // width() {
    //   (this.slopeParams.biasWidth > this.slopeParams.width)
    //     ? this.slopeParams.width = this.slopeParams.biasWidth
    //     : this.slopeParams.width = this.slopeParams.width;
    // },
    // biasWidth() {
    //   (this.slopeParams.biasWidth >= this.slopeParams.width)
    //     ? this.slopeParams.width = this.slopeParams.biasWidth
    //     : this.slopeParams.biasWidth = this.slopeParams.biasWidth;
    // },
  },
  methods: {
    showRowInfo(i) {
      this.rowId = i;
    },
    hideRowInfo() {
      this.rowId = 0;
    },
    getCursorPosition(e) {
      this.mouseTop = e.clientY;
      this.mouseLeft = e.clientX;
    },
    detectCursor() {
      document.addEventListener('mousemove', this.getCursorPosition);
      this.windowWidth = window.innerWidth;
    },
    unDetectCursor() {
      document.removeEventListener('mousemove', this.getCursorPosition);
    },
  },
  computed: {
    slopeFromState() {
      return (!this.isNav && !this.isDetails) || (this.isDetails && this.isPlate)
        ? this.$store.getters.getSlope(this.slopeId)
        : this.$store.getters.getSlope(this.navId);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    allSlopes() {
      return this.$store.getters.allSlopes;
    },
    slopeParams() {
      return this.slopeFromState.slopeParams[0];
    },
    rowsCount() {
      return Math.ceil((this.slopeFromState.slopeParams[0].width * 1000)
                       / this.slopeFromState.materialSize.width);
    },
    itemPerRow() {
      return (Math.ceil(480 / ((this.slopeFromState.materialSize.height / 1000) * this.scale))) + 1;
    },
    plateHeight() {
      return (this.slopeFromState.materialSize.height / 1000) * this.scale;
    },
    plateWidth() {
      return (this.slopeFromState.materialSize.width / 1000) * this.scale;
    },
    rowHeight() {
      return this.itemPerRow * this.plateHeight;
    },
    rowStartY() {
      return (this.changeHeightDown + this.scaledBiasHeight) - this.rowHeight;
    },
    arrowStrokeColor() {
      return this.isNav ? '#C8C8C8' : '#999999';
    },
    figureStrokeColor() {
      return this.isNav || this.isDetails ? '#959595' : '#333333';
    },
    strokeWidth() {
      return this.isNav || this.isDetails ? 2 : 4;
    },
    arrowsColor() {
      return '#999999';
    },
    figureSvgScale() {
      return this.isNav ? this.defaultSvgParams.navScale : 1;
    },
    arrowDirectionSize() {
      return this.isNav ? 5 : 10;
    },
    arrowHeight() {
      return `M${this.changeWidthRight + 30},${this.changeHeightUp + this.scaledBiasHeight}
      L${this.changeWidthRight + 30},${this.changeHeightDown + this.scaledBiasHeight}
      M${this.changeWidthRight + 35},${this.changeHeightUp + this.scaledBiasHeight + 6}
      L${this.changeWidthRight + 30},${this.changeHeightUp + this.scaledBiasHeight}
      M${this.changeWidthRight + 25},${this.changeHeightUp + this.scaledBiasHeight + 6}
      L${this.changeWidthRight + 30},${this.changeHeightUp + this.scaledBiasHeight}
      M${this.changeWidthRight + 35},${this.changeHeightDown + this.scaledBiasHeight - 6}
      L${this.changeWidthRight + 30},${this.changeHeightDown + this.scaledBiasHeight}
      M${this.changeWidthRight + 25},${this.changeHeightDown + this.scaledBiasHeight - 6}
      L${this.changeWidthRight + 30},${this.changeHeightDown + this.scaledBiasHeight}`;
    },
    arrowWidth() {
      return `M${this.changeWidthLeft},${this.changeHeightDown + this.scaledBiasHeight + 30}
      L${this.changeWidthRight},${this.changeHeightDown + this.scaledBiasHeight + 30}
      M${this.changeWidthLeft + 6},${this.changeHeightDown + this.scaledBiasHeight + 25}
      L${this.changeWidthLeft},${this.changeHeightDown + this.scaledBiasHeight + 30}
      M${this.changeWidthLeft + 6},${this.changeHeightDown + this.scaledBiasHeight + 35}
      L${this.changeWidthLeft},${this.changeHeightDown + this.scaledBiasHeight + 30}
      M${this.changeWidthRight - 6},${this.changeHeightDown + this.scaledBiasHeight + 25}
      L${this.changeWidthRight},${this.changeHeightDown + this.scaledBiasHeight + 30}
      M${this.changeWidthRight - 6},${this.changeHeightDown + this.scaledBiasHeight + 35}
      L${this.changeWidthRight},${this.changeHeightDown + this.scaledBiasHeight + 30}`;
    },
    arrowBiasHeight() {
      return `M${this.changeWidthLeft - 30},${this.changeHeightUp}
      L${this.changeWidthLeft - 30},${this.changeHeightUp + this.scaledBiasHeight}
      M${this.changeWidthLeft - 25},${(this.changeHeightUp) + 6}
      L${this.changeWidthLeft - 30},${this.changeHeightUp}
      M${this.changeWidthLeft - 35},${(this.changeHeightUp) + 6}
      L${this.changeWidthLeft - 30},${this.changeHeightUp}
      M${this.changeWidthLeft - 25},${this.changeHeightUp + this.scaledBiasHeight - 6}
      L${this.changeWidthLeft - 30},${this.changeHeightUp + this.scaledBiasHeight}
      M${this.changeWidthLeft - 35},${this.changeHeightUp + this.scaledBiasHeight - 6}
      L${this.changeWidthLeft - 30},${this.changeHeightUp + this.scaledBiasHeight}`;
    },
    arrowBiasWidth() {
      return `M${this.changeWidthLeft},${(this.changeHeightUp) - 30}
      L${this.changeWidthLeft + this.scaledBiasWidth},${(this.changeHeightUp) - 30}
      M${this.changeWidthLeft + 6},${(this.changeHeightUp) - 25}
      L${this.changeWidthLeft},${(this.changeHeightUp) - 30}
      M${this.changeWidthLeft + 6},${(this.changeHeightUp) - 35}
      L${this.changeWidthLeft},${(this.changeHeightUp) - 30}
      M${(this.changeWidthLeft + this.scaledBiasWidth) - 6},${(this.changeHeightUp) - 25}
      L${(this.changeWidthLeft + this.scaledBiasWidth)},${(this.changeHeightUp) - 30}
      M${(this.changeWidthLeft + this.scaledBiasWidth) - 6},${(this.changeHeightUp) - 35}
      L${(this.changeWidthLeft + this.scaledBiasWidth)},${(this.changeHeightUp) - 30}`;
    },
    arrowDirection() {
      return `M${this.arrowDirectionStartX},${this.arrowDirectionY}
      L${this.arrowDirectionEndX},${this.arrowDirectionY}
      M${this.arrowDirectionEndX - this.arrowDirectionSize},${this.arrowDirectionY - this.arrowDirectionSize}
      L${this.arrowDirectionEndX},${this.arrowDirectionY}
      M${this.arrowDirectionEndX - this.arrowDirectionSize},${this.arrowDirectionY + this.arrowDirectionSize}
      L${this.arrowDirectionEndX},${this.arrowDirectionY}`;
    },
    cornerLeftBottom() {
      return `M${this.changeWidthLeft}, ${this.changeHeightUp}
      L${this.changeWidthLeft + this.scaledBiasWidth}, ${this.changeHeightUp}
      M${this.changeWidthLeft + this.scaledBiasWidth}, ${this.changeHeightUp}
      L${this.changeWidthLeft + this.scaledBiasWidth}, ${this.changeHeightUp + this.scaledBiasHeight}
      M${this.changeWidthLeft + this.scaledBiasWidth}, ${this.changeHeightUp + this.scaledBiasHeight}
      L${this.changeWidthRight}, ${this.changeHeightUp + this.scaledBiasHeight}
      M${this.changeWidthRight}, ${this.changeHeightUp + this.scaledBiasHeight}
      L${this.changeWidthRight}, ${this.changeHeightDown + this.scaledBiasHeight}
      M${this.changeWidthRight}, ${this.changeHeightDown + this.scaledBiasHeight}
      L${this.changeWidthLeft}, ${this.changeHeightDown + this.scaledBiasHeight}
      M${this.changeWidthLeft}, ${this.changeHeightDown + this.scaledBiasHeight}
      L${this.changeWidthLeft}, ${this.changeHeightUp + this.scaledBiasHeight}
      M${this.changeWidthLeft}, ${this.changeHeightUp + this.scaledBiasHeight}
      L${this.changeWidthLeft}, ${this.changeHeightUp}
      M${this.changeWidthLeft}, ${this.changeHeightUp}`;
    },
    cornerLeftBottomMask() {
      return `M${this.changeWidthLeft}, ${this.changeHeightUp}
      L${this.changeWidthLeft + this.scaledBiasWidth}, ${this.changeHeightUp}
      L${this.changeWidthLeft + this.scaledBiasWidth}, ${this.changeHeightUp + this.scaledBiasHeight}
      L${this.changeWidthRight}, ${this.changeHeightUp + this.scaledBiasHeight}
      L${this.changeWidthRight}, ${this.changeHeightDown + this.scaledBiasHeight}
      L${this.changeWidthLeft}, ${this.changeHeightDown + this.scaledBiasHeight}
      L${this.changeWidthLeft}, ${this.changeHeightUp + this.scaledBiasHeight}
      L${this.changeWidthLeft}, ${this.changeHeightUp} Z`;
    },
    scaleH() { // коэффициент высоты
      return ((this.defaultSvgParams.baseHeight * this.figureSvgScale) * 100)
      / (this.slopeParams.height + this.slopeParams.biasHeight);
    },
    scaleW() { // коэффициент ширины
      return ((this.defaultSvgParams.baseWidth * this.figureSvgScale) * 100)
      / (this.slopeParams.width);
    },
    scale() { // применяемый коэффициент в зависимости от того какой из коэффициентов больше
      return (this.scaleW > this.scaleH) ? this.scaleH : this.scaleW;
    },
    changeWidthLeft() { // изменяем ширину влево
      return (((this.defaultSvgParams.width * this.figureSvgScale) / 2)
              - ((this.slopeParams.width * this.scale) / 2));
    },
    changeWidthRight() { // изменяем ширину вправо
      return (((this.defaultSvgParams.width * this.figureSvgScale) / 2)
              + ((this.slopeParams.width * this.scale) / 2));
    },
    changeHeightUp() { // изменяем высоту вверх
      return (((this.defaultSvgParams.height * this.figureSvgScale) / 2)
              - ((this.slopeParams.height * this.scale) / 2)) - (this.scaledBiasHeight / 2);
    },
    changeHeightDown() { // изменяем высоту вниз
      return (((this.defaultSvgParams.height * this.figureSvgScale) / 2)
              + ((this.slopeParams.height * this.scale) / 2)) - (this.scaledBiasHeight / 2);
    },
    scaledBiasHeight() { // размер вертикального смещения с применённым коэффициентом
      return (this.slopeParams.biasHeight * this.scale);
    },
    scaledBiasWidth() { // размер вертикального смещения с применённым коэффициентом
      return (this.slopeParams.biasWidth * this.scale);
    },
    arrowDirectionStartX() { // изменяем ширину направляющей стрелки влево
      return (((this.defaultSvgParams.width * this.figureSvgScale) / 2)
              - (((this.slopeParams.width / 2) * this.scale) / 2));
    },
    arrowDirectionEndX() { // изменяем ширину напрвляющей стрелки вправо
      return (((this.defaultSvgParams.width * this.figureSvgScale) / 2)
              + (((this.slopeParams.width / 2) * this.scale) / 2));
    },
    arrowDirectionY() { // изменяем положение напрвляющей стрелки по высоте
      return ((this.changeHeightDown + this.changeHeightUp) / 2) + this.scaledBiasHeight;
    },
  },
  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
</style>
